export { default } from './faq-section';
export { default as faqSectionRefConfig } from './faq-section.config';
